// Legacy entry point for the timezone-aware formatters. The implementation
// now lives in src/utils/datetime.js, which reads the admin's
// `defaultTimezone` from the global-settings cache instead of the dead
// `localStorage.timezone` key this module used to consult.
//
// The exports are kept at their original names and signatures so the
// device-management tables and detail pages that import from here need no
// changes. Prefer importing from `src/utils/datetime` in new code.

import moment from 'moment-timezone'

import {
  formatDateTime,
  formatDateOnly as formatDateOnlyInTimezone,
  getRelativeTime as getRelativeTimeInTimezone,
} from '../../utils/datetime'

export const formatDate = (date) => formatDateTime(date)

export const formatDateOnly = (date) => formatDateOnlyInTimezone(date)

export const getRelativeTime = (date) => getRelativeTimeInTimezone(date)

// Elapsed time between two UTC timestamps. Timezone-independent — the
// difference between two instants is the same in every zone — so this one
// stays on moment.utc directly.
export const durationCalculation = (startTimestamp, endTimestamp) => {
  const startTime = moment.utc(startTimestamp)
  const endTime = moment.utc(endTimestamp)

  const duration = moment.duration(endTime.diff(startTime))
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  return `${hours} h ${minutes} m`
}
